// extracted by mini-css-extract-plugin
export default {"sidebarWrapper":"styles_sidebarWrapper__elITm","list":"styles_list__14MJh"};